export enum GUIDKEYS {
  RNKIM = 'rnkim',
  ZAKUPKI_ROSNEFT = 'zakupki_rosneft',
  INVITE_ROSNEFT = 'invite_zakupki_rosneft',
  DEFAULT = 'default',
  REPORT_REGION = 'report_region',
  KIM = 'kim',
}

export type GuidUserType = {
  [key in GUIDKEYS]: {
    sectionID: string;
    userGuid: Array<string>;
  };
};
